import type { ComponentType } from "react";
import { IconBook, IconUsers, IconTarget, IconMessage } from "@/lib/tabler-icons";

export interface Achievement {
	icon: ComponentType<{ className?: string }>;
	title: string;
	description: string;
}

export const achievements: Achievement[] = [
	{
		icon: IconBook,
		title: "Autora Publicada",
		description:
			"Novela 'Todo lo que no ves' que aborda temas de infancia y familia",
	},
	{
		icon: IconUsers,
		title: "Fundadora",
		description:
			"Creadora de la Asociación Equilibrio para el bienestar social y comunitario",
	},
	{
		icon: IconTarget,
		title: "Activista Social",
		description:
			"Comprometida con la transformación social y el bienestar comunitario",
	},
	{
		icon: IconMessage,
		title: "Conferenciante",
		description:
			"Ponente en eventos sobre educación emocional y prevención de violencia",
	},
];
